import { render, staticRenderFns } from "./pager.vue?vue&type=template&id=be5c2c58&"
import script from "./pager.vue?vue&type=script&lang=js&"
export * from "./pager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports